import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import theme from '../../theme';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import NavBar from '../NavBar/NavBar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

function BlankPage() {
  return (
        <Box
          component='main'
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >
          <Container
            maxWidth='md'
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              height: '100%',
              textAlign: 'center',
            }}
          >
            <Typography variant='h4' component='h2' gutterBottom>
              Page Under Construction
            </Typography>
            <Typography variant='body1' gutterBottom>
              We're working hard to finish this page. Check back later!
            </Typography>
            {/* <LinearProgress /> */}
          </Container>
        </Box>
  );
}

export default BlankPage;
